import type { MessageId } from "@mailflare/shared";
import { create } from "zustand";

export interface UiState {
  /** Mobile navigation drawer visibility. */
  readonly sidebarOpen: boolean;
  /** Id of the message open in the reading pane (synchronized with the URL). */
  readonly selectedMessageId: MessageId | null;
  /** Keyboard-navigation cursor within the message list. */
  readonly focusedIndex: number;
  /** Keyboard shortcut help overlay visibility. */
  readonly shortcutsOpen: boolean;

  setSidebarOpen: (open: boolean) => void;
  toggleSidebar: () => void;
  selectMessage: (id: MessageId | null) => void;
  setFocusedIndex: (index: number) => void;
  setShortcutsOpen: (open: boolean) => void;
}

export const useUiStore = create<UiState>()((set) => ({
  sidebarOpen: false,
  selectedMessageId: null,
  focusedIndex: -1,
  shortcutsOpen: false,
  setSidebarOpen: (sidebarOpen) => set({ sidebarOpen }),
  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
  selectMessage: (selectedMessageId) => set({ selectedMessageId }),
  setFocusedIndex: (focusedIndex) => set({ focusedIndex }),
  setShortcutsOpen: (shortcutsOpen) => set({ shortcutsOpen }),
}));
